var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('titles',{attrs:{"titlename":"我的训练","titlecontent":"这里可以看到我的训练","mbx":_vm.paths}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }